module.exports = __webpack_public_path__ + "img/3480edabb95ee0e24aacf371a70116a0.png";